// IMPORT PACKAGE REFERENCES
import React from 'react';

// COMPONENT
export class HomePage extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return  <div>Error - Invalid Pathway ID</div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/HomePage.js